<template>
  <div>
    <b-row class="m-0">
        <b-col class="p-0">
        <fieldset class="border p-3">
            <legend  class="w-auto bg-facebook px-2 py-1 text-white rounded border h6">WORK EXPERIENCES  <font-awesome-icon icon="plus-circle" class="ml-3 cursor-pointer" @click="work_experience_modal=true" /></legend>
                <table class="table table-bordered mt-2 mb-0 table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col">Company</th>
                            <th scope="col">Job Title</th>
                            <th scope="col" class="text-center">Employment Date</th>
                            <th scope="col" class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody class="bg-white text-dark">
                        <tr v-for="(manpower_work_experience, index) in params.form.manpower_work_experiences">
                            <td>
                                {{manpower_work_experience.company}}
                            </td>
                            <td>
                                {{manpower_work_experience.job_title}}
                            </td>
                            <td>
                                <b-badge variant="warning">{{manpower_work_experience.from}}</b-badge> to <b-badge variant="warning">{{manpower_work_experience.to}}</b-badge>
                            </td>
                            <td class="text-center">
                                <b-button size="sm" variant="danger" @click="deleteWorkExperience(manpower_work_experience.id)"><font-awesome-icon icon="minus-circle" /> Remove</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>


            <fieldset class="border p-3 mt-3 bg-light">
                <legend  class="w-auto bg-warning px-2 py-1 text-white rounded border h6">EDUCATION  <font-awesome-icon icon="plus-circle" class="ml-3 cursor-pointer" @click="education_modal=true" /></legend>
                <table class="table table-bordered mt-2 mb-0 table-sm">
                    <thead class="thead-dark">
                    <tr>
                        <th scope="col">Education Level</th>
                        <th scope="col">Institute</th>
                        <th scope="col" class="text-center">Major</th>
                        <th scope="col" class="text-center">Year</th>
                        <th scope="col" class="text-center">GPA</th>
                        <th scope="col" class="text-center">Date Attended</th>
                        <th scope="col" class="text-center">Action</th>
                    </tr>
                    </thead>
                    <tbody class="bg-white text-dark">
                    <tr v-for="(education, index) in params.form.manpower_educations">
                        <td>
                            {{education.education_level.description}}
                        </td>
                        <td>
                            {{education.institute}}
                        </td>
                        <td>
                            {{education.major}}
                        </td>
                        <td>
                            {{education.year}}
                        </td>
                        <td>
                            {{education.gpa}}
                        </td>
                        <td>
                            <b-badge variant="warning">{{education.start_date}}</b-badge> to <b-badge variant="warning">{{education.end_date}}</b-badge>
                        </td>
                        <td class="text-center">
                            <b-button size="sm" variant="danger" @click="deleteEducation(education.id)"><font-awesome-icon icon="minus-circle" /> Remove</b-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </fieldset>
        </b-col>
    </b-row>

      <b-modal v-model="work_experience_modal" centered size="md" body-class="p-0" :hide-footer="true" :hide-header="true">
          <work-experience-form @save="save"/>
      </b-modal>

      <b-modal v-model="education_modal" centered size="md" body-class="p-0" :hide-footer="true" :hide-header="true">
          <education-form @save="save"/>
      </b-modal>
      
  </div>
</template>
<script>

    import SwalMixin from "@/views/mixins/Swal.js";
    import WorkExperienceForm from './WorkExperienceForm.vue';
    import EducationForm from './EducationForm.vue';
    import NumberFormatComponent from '@/views/helpers/NumberFormatComponent.vue';
    export default {
        mixins:[SwalMixin],
        components: {NumberFormatComponent,WorkExperienceForm,EducationForm},
        props:{
            params: {
                type: Object,
                default: {},
                required: true
            },
        },
        data() {
            return {
                work_experience_modal:false,
                education_modal:false
            }
        },
        methods:{
            deleteWorkExperience(id){
                this.swalConfirmDelete((data)=>{
                    if (data.value) {
                        this.is_saving=true;
                        this.axios.delete('maintenance/manpowers/work-experiences/delete',{ data: {id:id} }).then(response => {
                            this.swalTransactionCompleted();
                            this.is_saving=false;
                            this.$emit('save');
                        }).catch(error => {
                            this.swal_transaction_error_data.text = error.response.data;
                            this.swalRequestError();
                            this.is_saving=false;
                        });
                    }
                });

            },
            deleteEducation(id){
                this.swalConfirmDelete((data)=>{
                    if (data.value) {
                        this.is_saving=true;
                        this.axios.delete('maintenance/manpowers/education/delete',{ data: {id:id} }).then(response => {
                            this.swalTransactionCompleted();
                            this.is_saving=false;
                            this.$emit('save');
                        }).catch(error => {
                            this.swal_transaction_error_data.text = error.response.data;
                            this.swalRequestError();
                            this.is_saving=false;
                        });
                    }
                });

            },
            save(){
                this.$emit('save');
                this.work_experience_modal=false;
                this.education_modal=false;
            },
        }
    }
</script>
